import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/Pages/Admin/Store/index";
import { trekService } from "@/Pages/Admin/Modules/ManagePackage/Services/Trekservice";


@Module({ name: "Permission", namespaced: true, dynamic: true, store })
class Permission extends VuexModule {
  public permissionList: any = [];
  public permissionsAllList: any = [];
  public allocatedPermissions: any = {};
  public userRole: any = "";
  // public permissionList: any = [];
  @Mutation
  public GET_PERMISSION_LIST(data: any) {
    console.log("Allocated permission from store action", data.data.data);
    this.permissionList = data.data.data;
  }

  @Action
  public async getPermission(): Promise<any> {
    return await new Promise((resolve, reject) => {
      trekService
        .getPermissionList()
        .then((res: any) => {
          this.context.commit("GET_PERMISSION_LIST", res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  @Mutation
  public GET_ALL_PERMISSION_LIST(data: any) {
    console.log("All permission  List from store action", data.data.data);
    this.permissionsAllList = data.data.data;
  }

  @Action
  public async getAllPermissions(): Promise<any> {
    return await new Promise((resolve, reject) => {
      trekService
        .getAllPermissionList()
        .then((res: any) => {
          this.context.commit("GET_ALL_PERMISSION_LIST", res);
          //   console.log("from store action" , res.data.data);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
  @Mutation
  public SET_USER_ROLE(data: string) {
    // console.log("from store action", data.data.data);
    this.userRole = data;
  }

  @Action
  public async GetUserRole(role: string): Promise<any> {
    this.context.commit("SET_USER_ROLE", role);
  }
}

export default getModule(Permission);
